import { capitalizeAllIfLower, formatDate } from '@btime/helpers'
import { compose, join, path, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText, Text, Title } from '../../../../components/presentation/Text'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Panel, { PanelContent } from '../../../../components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'
import ServiceOrderIndicatorsBoxes from './ServiceOrderIndicatorsBoxes'
import { useSessionPermission } from '@btime/react-session'

const ServiceOrderDetailsPanel = ({ hideIndicators, serviceOrder, counters }) => {
  const { t } = useTranslation('serviceOrders')
  const switchChecklistNameByYearlyId = useSessionPermission('switchChecklistNameByYearlyId')
  const yearlyId = switchChecklistNameByYearlyId ? serviceOrder.yearlyId : undefined
  const title =
    yearlyId ||
    serviceOrder.name ||
    compose(capitalizeAllIfLower, prop('name'))(serviceOrder.checklist || serviceOrder.service)
  const user = compose(capitalizeAllIfLower, path(['user', 'name']))(serviceOrder)
  const checkinAt = formatDate('DD/MM/YYYY HH:mm', serviceOrder.insertedAt || serviceOrder.createdAt)
  const slaExpiresAt = formatDate('DD/MM/YYYY HH:mm', serviceOrder.slaExpiresAt)

  const subtitle = join(' | ', [user])

  return (
    <Panel lineBorder noPadding>
      <PanelContent mediumPadding>
        <FlexGrid align="flex-start" wrap>
          <FlexCol flex={1}>
            <Separator weight={3} />
            <Title size="h2">{title}</Title>
            <Text>{subtitle}</Text>
          </FlexCol>
          <FlexCol hideOn="sm">
            <SmallText noWrap>
              {t('show.openedAt')}: {checkinAt}
            </SmallText>
            {slaExpiresAt && (
              <SmallText noWrap>
                {t('show.sla')}: {slaExpiresAt}
              </SmallText>
            )}
          </FlexCol>
        </FlexGrid>
      </PanelContent>
      {!hideIndicators && <ServiceOrderIndicatorsBoxes counters={counters} />}
    </Panel>
  )
}

export default ServiceOrderDetailsPanel
